// extracted by mini-css-extract-plugin
var _1 = "close-m5ovn";
var _2 = "spec-FyL8Y";
export { _1 as "close", _2 as "spec" }
